import React from 'react';
import PropTypes from 'prop-types';

import styles from './UsersListHeader.scss';
import ParagraphSubheaderWithIcon from 'Components/ParagraphSubheaderWithIcon';
import FlashMessage from 'Components/FlashMessage';

class UsersListHeader extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      offset: 0,
    };

    this.setOffset = this.setOffset.bind(this);
  }

  componentDidMount() {
    this.setOffset();
  }

  componentDidUpdate() {
    this.setOffset();
  }

  setOffset() {
    const offset = this.el.offsetHeight;
    if (offset !== this.state.offset) {
      this.setState({ offset: this.el.offsetHeight }, () => {
        this.props.saveHeight(offset);
      });
    }
  }

  render() {
    const { type, title, actionButtons, headerStuck, message } = this.props;
    return (
      <div
        ref={div => {
          this.el = div;
        }}
        className={`UsersListHeader UsersListHeader--${type}${
          headerStuck ? ' is-stuck' : ''
        }`}
      >
        <div className="UsersListHeader__container">
          <ParagraphSubheaderWithIcon text={title} type={type} />
          {actionButtons && actionButtons.length ? (
            <div className="UsersListHeader__actions">{actionButtons}</div>
          ) : null}
          {message ? (
            <FlashMessage
              {...message}
              animationType="fade"
              location="user-list-header"
            />
          ) : null}
        </div>
      </div>
    );
  }
}

UsersListHeader.propTypes = {
  saveHeight: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['activity', 'student']),
  title: PropTypes.node.isRequired,
  actionButtons: PropTypes.array,
  headerStuck: PropTypes.bool,
  message: PropTypes.node,
};

export default UsersListHeader;
